$(function() {

    // コミュニティ一覧
    $('.js-community-filter').click(function() {
        var name = $(this).data('name');

        var value;
        if (name == 'entried') {
            if ($(this).prop('checked')) {
                value = 1;
            } else {
                value = 0;
            }
        } else {
            value = $(this).data('value');
        }

        $(`.js-community-filterForm [name=${name}]`).val(value);
        $(`.js-community-filterForm`).submit();
    });

    // コメント入力
    $('.js-community-commentOpen').click(function () {
        const topicId = $(this).data('topic-id');
        $(`.js-community-commentForm[data-topic-id=${topicId}]`).show();
    });

    // コメントキャンセル
    $('.js-community-commentCancel').click(function () {
        const topicId = $(this).data('topic-id');
        $(`.js-community-commentForm[data-topic-id=${topicId}] [name=comment]`).val('');
        $(`.js-community-commentForm[data-topic-id=${topicId}]`).hide();
    });

    // コメント返信入力
    $('.js-community-replyOpen').click(function () {
        const replyId = $(this).data('reply-id');
        $(`.js-community-replyForm[data-reply-id=${replyId}]`).show();
    });

    // コメント返信キャンセル
    $('.js-community-replyCancel').click(function () {
        const replyId = $(this).data('reply-id');
        $(`.js-community-replyForm[data-reply-id=${replyId}] [name=comment]`).val('');
        $(`.js-community-replyForm[data-reply-id=${replyId}]`).hide();
    });

    // コメントもっと見る
    $('.js-community-showMoreComments').click(function () {
        if ($('.js-community-moreComments').is(':visible')) {
            $(this).text('もっと見る ▼');
        } else {
            $(this).text('閉じる ▲');
        }
        $('.js-community-moreComments').slideToggle();
    });

    // コメント送信のバリデーション
    $('.js-community-commentForm button[type="submit"]').click(function (e) {
        var $form = $(this).parents('.js-community-commentForm');

        if (!$('[name="comment"]', $form).val()) {
            $('.box-textarea', $form).addClass('is-error');
            $('.box-textarea .is-error-txt', $form).show();
            e.preventDefault();
        }
    });

    // コメント返信のバリデーション
    $('.js-community-replyForm button[type="submit"]').click(function (e) {
        var $form = $(this).parents('.js-community-replyForm');

        if (!$('[name="comment"]', $form).val()) {
            $('.box-textarea', $form).addClass('is-error');
            $('.box-textarea .is-error-txt', $form).show();
            e.preventDefault();
        }
    });

    // コミュニティー参加モーダルの表示
    $('.js-community-entryDialog--trigger').click(function (e) {
        $('#area-event-modal').show();
    });

    // コミュニティ　いいね
    $('.js-community-goodTrigger').click(function (e) {
        e.preventDefault();

        const apiUrl = $(this).data('api-url');
        const communityId = $(this).data('community-id');

        $.post(apiUrl).done(function (response) {
            if (response.status) {
                if (response.good) {
                    $(`.js-community-goodTrigger[data-community-id=${communityId}]`)
                        .addClass('icn-like-on')
                        .removeClass('icn-like-off');

                    const countEle = $(`.js-community-goodCount[data-community-id=${communityId}]`);
                    countEle.text(parseInt(countEle.text()) + 1);
                } else {
                    $(`.js-community-goodTrigger[data-community-id=${communityId}]`)
                        .removeClass('icn-like-on')
                        .addClass('icn-like-off');
                        
                    const countEle = $(`.js-community-goodCount[data-community-id=${communityId}]`);
                    countEle.text(parseInt(countEle.text()) - 1);
                }
            } else {
                alert(response.message);
            }
        }).fail(function () {
            alert('いいねできませんでした。');
        });
    });

    // コミュニティ　お気に入り
    $('.js-community-favoriteTrigger').click(function (e) {
        e.preventDefault();

        const apiUrl = $(this).data('api-url');
        const communityId = $(this).data('community-id');

        $.post(apiUrl).then(function (response) {
            if (response.status) {
                if (response.favorite) {
                    $(`.js-community-favoriteTrigger[data-community-id=${communityId}]`)
                        .addClass('icn-heart-on')
                        .removeClass('icn-heart-off');

                    const countEle = $(`.js-community-favoriteCount[data-community-id=${communityId}]`);
                    countEle.text(parseInt(countEle.text()) + 1);
                } else {
                    $(`.js-community-favoriteTrigger[data-community-id=${communityId}]`)
                        .removeClass('icn-heart-on')
                        .addClass('icn-heart-off');

                    const countEle = $(`.js-community-favoriteCount[data-community-id=${communityId}]`);
                    countEle.text(parseInt(countEle.text()) - 1);
                }
            } else {
                alert(response.message);
            }
        }).fail(function () {
            alert('お気に入りできませんでした。');
        });
    });

    // コミュニティトピック削除
    $('.js-community-topic-removeTrigger').click(function (e) {
        const topicId = $(this).data('topic-id');
        $(`.js-community-topic-removeForm[data-topic-id=${topicId}]`).submit();
    });

});